import AnimationPop from "components/block-elements/animation-pop/animation-pop";
import SiteConfigurationStore from "components/stores/site-configuration-store";

const formatQueueTimeLabel = (queueTime) => {
  const queueLabel = SiteConfigurationStore.getLabel("QUEUE_TIME");
  const queueLabelMinutes = SiteConfigurationStore.getLabel("QUEUE_MINUTES");
  const queueLabelStoppage = SiteConfigurationStore.getLabel("RIDE_STOPPAGE");
  return queueTime?.state === 0
    ? `${queueLabel}: ${queueTime?.queueTimeText} ${queueLabelMinutes}`
    : queueLabelStoppage;
};

const QueueTimeDisplay = ({ queueTime }) => {
  const queueTimeDisplay = formatQueueTimeLabel(queueTime);
  return <AnimationPop content={queueTimeDisplay} />;
};

export default QueueTimeDisplay;
